import React from 'react';
import ReactDOM from 'react-dom';
import AppContextProvider from './ui/store/contexts/AppContext';
import NavigationContextProvider from './ui/store/contexts/NavigationContext';
import { ErrorBoundary } from "react-error-boundary";
import { HashRouter  } from "react-router-dom";
import { App } from './ui/App.jsx';
import { ScrollToTop } from './ui/partials';

const DATA = window.APP_DATA || {};
const SETTINGS = window.APP_SETTINGS || {};

if (SETTINGS.isLocal) {
  require('webpack-hot-middleware/client');
  console.log('Development mode!');
}
 
ReactDOM.render(
	<AppContextProvider appData={DATA} appSettings={SETTINGS} query={window.location.search}>
		<HashRouter>
			<NavigationContextProvider>
				<ScrollToTop>
					<ErrorBoundary fallback={<div>Something went wrong</div>}>
						<App/>
					</ErrorBoundary>
				</ScrollToTop>
			</NavigationContextProvider>
		</HashRouter >
	</AppContextProvider>,
	document.getElementById('react-root')
  )